import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import CustomActionsTableServer from "../../../components/CustomActionsTableServerSide"
import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import DeleteIcon from "@mui/icons-material/Delete"
import CustomBackdrop from "../../../components/CustomBackdrop"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const AdministradorPedidosMostradorEliminar = () => {
  const { mutateAsync: deleteCita, isPending: isDeletingCita } = useDeleteCita()
  function useDeleteCita() {
    // const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (pednumped) => {
        const options = {
          method: "DELETE",
          body: JSON.stringify({ pednumped }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        const response = await fetchwrapper(`/AdministradorPedidosMostrador/deleteCita`, options)
        return response
      },

      //   // actualizacion optimista
      //   onMutate: (clicodigo) => {
      //     queryClient.setQueryData(["Asociaciones"], (prevAsociaciones) =>
      //       prevAsociaciones?.filter((asoci) => asoci.clicodigo !== clicodigo),
      //     )
      //   },
      //   onSuccess: () => {
      //     // Invalidate and refetch client data
      //     queryClient.invalidateQueries(["Cliente", id])
      //     queryClient.invalidateQueries(["clienteXproveedor"])
      //   },
    })
  }

  //   const {
  //     dataCabeceraSinDetalle,
  //     isLoadingCabeceraSinDetalle,
  //     isErrorCabeceraSinDetalle,
  //     refetchCabeceraSinDetalle,
  //     isFetchingCabeceraSinDetalle,
  //   } = useGetDataCabeceraSinDetalle()

  //   function useGetDataCabeceraSinDetalle() {
  //     return useQuery({
  //       queryKey: ["AdministradorPedidosMostradorCitasBuscarSinDetalle", 1, {}],
  //       queryFn: async () => {
  //         const response = await fetchwrapper("/AdministradorPedidosMostrador/getCitasSinDetalle", {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             page: 1,
  //             perPage: 10,
  //             filters: {},
  //           }),
  //         })
  //         setTotalPages(result.total_pages)
  //         return result.data
  //       },
  //       keepPreviousData: false,
  //       retry: 1,
  //     })
  //   }

  const handleDeleteCita = async (row, useGetObjActionsTableServer) => {
    const pednumped = row.pednumped
    const { refetch } = useGetObjActionsTableServer
    try {
      await deleteCita(pednumped)
      await refetch()
    } catch (error) {
      alert("Error al eliminar la cita")
      console.log("Error completo: " + error)
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        ></div>
        <CustomBackdrop isLoading={isDeletingCita} />

        <Box className={StyledRoot}>
          <CustomActionsTableServer
            endpoint="/AdministradorPedidosMostrador/getCitasSinDetalle"
            errorMsgFilterSearch="Error en cargar datos"
            queryKeyModal="AdministradorPedidosMostradorCitasBuscarSinDetalle"
            perPage={10}
            rowActions={[
              {
                label: "Eliminar",
                key: "EliminarAction",
                icon: <DeleteIcon sx={{ color: "#F92C43" }} />,
                onClick: (row, useGetObjActionsTableServer) => {
                  handleDeleteCita(row?.original, useGetObjActionsTableServer)
                },
              },
            ]}
            columnsTable={[
              {
                accessorKey: "pednumped",
                header: "ID Cita",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "vennombre",
                header: "Vendedor",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "nickname",
                header: "Nickname",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "comentario",
                header: "Comentario",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "pedfecemi",
                header: "Fecha Emisión",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },
              {
                accessorKey: "pedfecven",
                header: "Fecha Vencimiento",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AdministradorPedidosMostradorEliminar
